
export function errDailog(that, code, done=null, msg='网络异常，请稍后重试！'){
    //token过期处理
    if (code==10005){
        // alert("errDailog 过期")
        if(done!=null){
            // done()
        }
    }else{
        // alert("errDailog 对话")
        that.$myDialog({
            logo: 'null',
            text: msg,
            btnOK: "确认",
            callBack: (state)=>{
                if (state){
                    if(done!=null) {
                        //策划要求不开重试
                        // done()
                    }
                }
            }
        });
    }
}
